import { IProject } from '@app/models/project';

export interface State {
    selectedProject: IProject;
    isSelectedProjectLoading: boolean;
    filters: string;
    projects: IProject[];
    filteredProjects: IProject[];
    isLoading: boolean;
}

export const initializeProjectsState = (): State => {
    return {
        projects: [],
        filteredProjects: [],
        isLoading: false,
        filters: null,
        selectedProject: null,
        isSelectedProjectLoading: false,
    };
};
